<template>
  <FormulateInput
    v-bind="field"
    validation-behavior="live"
    class="p-0"
    :help="true"
    :listGetter="computedListGetter"
    :value="computedValue"
    :fullObject="fullObject"
    @input="handleInput"
    @update:fullObject="$emit('update:fullObject', $event)"
  />
</template>

<script>
import * as Address from '@/services/rest-api/lib/delivery/address'

export default {
  props: {
    value: {},
    field: {},
    fullObject: {},
    otherAdressFullObject: {},
    formValues: {},
    isShowingData: {},
  },
  emits: ['input', 'update:fullObject'],
  computed: {
    computedValue() {
      // if it's empty, always return null
      if (this.value === '' || this.value === false) return null

      return typeof this.value === 'string' ? Number(this.value) : this.value
    },
    computedListGetter() {
      const customerId = this.formValues.shipped_customer_id ?? undefined
      let listGetter = Address.get()

      // set listGetter if customer id is selected
      if (customerId !== undefined || customerId !== null) {
        listGetter = Address.get(`with_customer_id eq '${customerId}'`)
      }

      return listGetter
    },
  },
  watch: {
    'formValues.shipped_customer_id': function () {
      // Return if it's loading data
      if (this.isShowingData) return

      // if it's loading, changes in customer id not impact addresses
      if (this.isLoading) return

      // reset address if customer id is changing
      this.$emit('input', null)
      this.$emit('update:fullObject', {})
    },
  },
  methods: {
    handleInput(newValue) {
      // if newValue is empty, always set null
      if (newValue === '' || newValue === false || newValue === undefined) {
        this.$emit('input', null)
        return
      }

      // nothing happened when newValue is null
      if (newValue === null) return

      // if newValue has same value with other address field
      if (newValue == this.otherAdressFullObject?.id) {
        this.$mcToast.error('Alamat Tujuan tidak boleh sama dengan Alamat Asal')
        this.$emit('input', null)
        this.$emit('update:fullObject', {})

        return
      }

      this.$emit('input', Number(newValue))
    },
  },
}
</script>
